<div markdown [data]="text" [ngClass]="classes" (ready)="onReady($event)"></div>
